import React from 'react';
import './App.css';

import {Provider} from 'react-redux'
import {ProtectedRoute} from './protected_route';
import {BrowserRouter,Switch,Route,MemoryRouter} from 'react-router-dom';
import store from './store';
import SplashScreen from './components/SplashScreen';
import IntroScreen from './components/IntroScreen';
import MainMenuScreen from './components/MainMenuScreen';
import AboutScreen from './components/AboutScreen';
import SourcesScreen from './components/SourcesScreen';
import SettingsScreen from './components/SettingsScreen';
import GameModeScreen from './components/GameModeScreen';
import ModeIntroScreen from './components/ModeIntroScreen';
import TrueFalseScreen from './components/TrueFalseScreen';
import GameMainScreen from './components/GameMainScreen';
import ResultScreen from './components/ResultScreen';
import LanguageScreen from './components/LanguageScreen';
function App() {
  return (
    // basename="./"
    <MemoryRouter basename={'/game-skins/build-rev79-TUGQhb2Uf'}> 
      <Provider store={store}>
        <div className="App container">
          <Switch>
            <Route path = "/languagescreen" component = {LanguageScreen}/>
            <Route path = "/introscreen" component = {IntroScreen}/>
            <Route path = "/mainmenu" component = {MainMenuScreen}/> 
            <Route path = "/about" component = {AboutScreen}/> 
            <Route path = "/sources" component = {SourcesScreen}/> 
            <Route path = "/settings" component = {SettingsScreen}/> 
            <Route path = "/gamemode" component = {GameModeScreen}/> 
            <Route path = "/gamemodeintro" component = {ModeIntroScreen}/> 
            <Route path = "/truefalse" component = {TrueFalseScreen}/> 
            <Route path = "/gamescreen" component = {GameMainScreen}/> 
            <Route path = "/resultscreen" component = {ResultScreen}/> 

            <Route path = "/" component={SplashScreen}/>
            <Route path = "*" component={()=>"404 NOT FOUND"}/> {/* create 404 module for this */}
            
          </Switch>
        </div>
      </Provider>
    </MemoryRouter>
  );
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js